import React from "react";
import { Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import "./index.less";
import { useTranslation } from "react-i18next";
type props = {
  label: string;
  onClick?: any;
  disabled?: boolean;
  isLoading?: boolean;
  height?: string;
  fontSize?: string;
  borderRadius?: string;
};

const AuthButtonComponent: React.FC<props> = ({ label, onClick, disabled, isLoading = false, height, fontSize, borderRadius }) => {
  const { t } = useTranslation();

  const buttonStyle: React.CSSProperties = {
    ...(height ? { height } : {}),
    ...(fontSize ? { fontSize } : {}),
    ...(borderRadius ? { borderRadius } : {}),
  };

  return (
    <Button className="authBtn" onClick={onClick} disabled={disabled || isLoading} style={buttonStyle}>
      {isLoading ? <LoadingOutlined style={{ fontSize: 24 }} spin /> : t(label)}
    </Button>
  );
};

export default AuthButtonComponent;
